import { defineMessages } from 'react-intl';

export const NavigationMessages = defineMessages({
  cancelEstimation: {
    id: 'estimationNavigation.cancelEstimation',
    defaultMessage: 'Cancel Estimation',
  },
  version: {
    id: 'estimationNavigation.version',
    defaultMessage: 'version',
  },
  basics: {
    id: 'estimationNavigation.basics.mainTitle',
    defaultMessage: 'Create new estimate',
  },
  project: {
    id: 'estimationNavigation.basics.project',
    defaultMessage: 'Project',
  },
  projectType: {
    id: 'estimationNavigation.basics.projectType',
    defaultMessage: 'Project Type',
  },
  methodology: {
    id: 'estimationNavigation.basics.methodology',
    defaultMessage: 'Methodology',
  },
  metadata: {
    id: 'estimationNavigation.metadata.mainTitle',
    defaultMessage: 'Master Data',
  },
  metadataMandatory: {
    id: 'estimationNavigation.metadata.mandatory',
    defaultMessage: 'Mandatory',
  },
  metadataOptional: {
    id: 'estimationNavigation.metadata.optional',
    defaultMessage: 'Optional',
  },
  phases: {
    id: 'estimationNavigation.phases',
    defaultMessage: 'Phases',
  },
  estimating: {
    id: 'estimationNavigation.estimating',
    defaultMessage: 'Estimate',
  },
  resourcing: {
    id: 'estimationNavigation.resourcing',
    defaultMessage: 'Resource',
  },
  costing: {
    id: 'estimationNavigation.costing',
    defaultMessage: 'Cost',
  },
  review: {
    id: 'estimationNavigation.review',
    defaultMessage: 'Review',
  },
  currentVersion: {
    id: 'estimationNavigation.currentVersion',
    defaultMessage: 'Version {versionName}',
  },
  wizardMode: {
    id: 'estimationNavigation.wizardMode',
    defaultMessage: 'Wizard Mode',
  },
});
